import React from "react";
import { observer } from "mobx-react-lite";
import { Dialog } from "@/components/toolkit/Dialog";
import { ConfirmDialog } from "@/components/toolkit/ConfirmDialog";
import { TextInput } from "@/components/toolkit/TextInput";
import { Clickable } from "@/components/toolkit/Clickable";
import { CodeSectionStore } from "./store";
import { t } from "@/i18n";

export const FileContextMenuDialogs = observer(({ store }: { store: CodeSectionStore }) => (
    <>
        {store.deleteConfirmPath && (
            <ConfirmDialog
                title={t("file_delete_title")}
                message={t("file_delete_confirm").replace("{path}", store.deleteConfirmPath.split("/").filter(Boolean).pop() ?? store.deleteConfirmPath)}
                confirmLabel={t("file_delete_btn")}
                danger
                onConfirm={() => store.deleteFile()}
                onCancel={() => store.cancelDelete()}
            />
        )}
        {store.renamePath && (
            <Dialog title={t("file_rename_title")} onClose={() => store.cancelRename()}>
                <TextInput
                    className="code_section__rename_input"
                    value={store.renameValue}
                    autoFocus
                    onChange={(v: string) => store.setRenameValue(v)}
                    onEnter={() => store.submitRename()}
                    placeholder={t("file_rename_placeholder")}
                />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
                    <Clickable onClick={() => store.cancelRename()}>
                        <button className="code_section__dialog_btn">{t("settings_cancel")}</button>
                    </Clickable>
                    <Clickable onClick={() => store.submitRename()}>
                        <button
                            className="code_section__dialog_btn code_section__dialog_btn--primary"
                            disabled={store.isRenaming}
                        >
                            {store.isRenaming ? "..." : t("file_rename_btn")}
                        </button>
                    </Clickable>
                </div>
            </Dialog>
        )}
        {store.createFolderParentPath !== null && (
            <Dialog title={t("file_create_folder_title")} onClose={() => store.cancelCreateFolder()}>
                <TextInput
                    className="code_section__rename_input"
                    value={store.createFolderName}
                    autoFocus
                    onChange={(v: string) => store.setCreateFolderName(v)}
                    onEnter={() => store.submitCreateFolder()}
                    placeholder={t("file_create_folder_placeholder")}
                />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
                    <Clickable onClick={() => store.cancelCreateFolder()}>
                        <button className="code_section__dialog_btn">{t("settings_cancel")}</button>
                    </Clickable>
                    <Clickable onClick={() => store.submitCreateFolder()}>
                        <button
                            className="code_section__dialog_btn code_section__dialog_btn--primary"
                            disabled={store.isCreatingFolder}
                        >
                            {store.isCreatingFolder ? "..." : t("file_create_folder_btn")}
                        </button>
                    </Clickable>
                </div>
            </Dialog>
        )}
        {store.createFileParentPath !== null && (
            <Dialog title={t("file_create_file_title")} onClose={() => store.cancelCreateFile()}>
                <TextInput
                    className="code_section__rename_input"
                    value={store.createFileName}
                    autoFocus
                    onChange={(v: string) => store.setCreateFileName(v)}
                    onEnter={() => store.submitCreateFile()}
                    placeholder={t("file_create_file_placeholder")}
                />
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
                    <Clickable onClick={() => store.cancelCreateFile()}>
                        <button className="code_section__dialog_btn">{t("settings_cancel")}</button>
                    </Clickable>
                    <Clickable onClick={() => store.submitCreateFile()}>
                        <button
                            className="code_section__dialog_btn code_section__dialog_btn--primary"
                            disabled={store.isCreatingFile}
                        >
                            {store.isCreatingFile ? "..." : t("file_create_file_btn")}
                        </button>
                    </Clickable>
                </div>
            </Dialog>
        )}
    </>
));
